import { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

import ButtonDesign from "../../components/ButtonDesign/ButtonDesign";
import NavBarCustom from "../../components/NavBarCustom/NavBarCustom";
import { ScrollTop } from "../../components/ScrollTop/ScrollTop";
import Contact from "../../containers/Contact/Contact";
import Footer from "../../containers/Footer/Footer";
import Portfolio from "../../containers/Portfolio/Portfolio";
import Reviews from "../../containers/Reviews/Reviews";
import Services from "../../containers/Services/Services";
import Team from "../../containers/Team/Team";

import BackgroundImage from "../../assets/images/BackgroundImage.webp";

import "../../App.css";
import "./HomePage.css";

const HomePage = (props) => {
	const { t } = useTranslation();

	const [actualElement, setActualElement] = useState();
	const homeRef = useRef(null);
	const servicesRef = useRef(null);
	const portfolioRef = useRef(null);
	const teamRef = useRef(null);
	const contactRef = useRef(null);
	const reviewsRef = useRef(null);
	const footerRef = useRef(null);

	useEffect(() => {
		// Scroll to the top when the component mounts
		window.scrollTo(0, 0);

		const observer = new IntersectionObserver(
			([entry]) => {
				if (entry.isIntersecting) {
					setActualElement(entry.target.id);
				}
			},
			{
				root: null, // viewport
				rootMargin: "0px", // no margin
				threshold: 0.6, // 60% of target visible
			}
		);

		if (homeRef.current) {
			observer.observe(homeRef.current);
		}
		if (servicesRef.current) {
			observer.observe(servicesRef.current);
		}
		if (portfolioRef.current) {
			observer.observe(portfolioRef.current);
		}
		if (teamRef.current) {
			observer.observe(teamRef.current);
		}
		if (contactRef.current) {
			observer.observe(contactRef.current);
		}
		if (reviewsRef.current) {
			observer.observe(reviewsRef.current);
		}
		if (footerRef.current) {
			observer.observe(footerRef.current);
		}

		// Clean up the observer
		return () => {
			if (homeRef.current) {
				observer.unobserve(homeRef.current);
			} else if (servicesRef.current) {
				observer.unobserve(servicesRef.current);
			} else if (portfolioRef.current) {
				observer.unobserve(portfolioRef.current);
			} else if (teamRef.current) {
				observer.unobserve(teamRef.current);
			} else if (contactRef.current) {
				observer.unobserve(contactRef.current);
			} else if (reviewsRef.current) {
				observer.unobserve(reviewsRef.current);
			} else if (footerRef.current) {
				observer.unobserve(footerRef.current);
			}
		};
	}, []);

	return (
		<div className="navbar-correction">
			{/* META TAGS */}
			<Helmet>
				<title>
					Diseño Web Creativo y Personalizado para Pymes | DevAcuarela
				</title>
				<meta
					name="description"
					content="Creamos tu web desde cero o rediseñamos la tuya. Diseño único, asesoría completa y sin tecnicismos. Tu negocio online, fácil y atractivo."
				/>
			</Helmet>

			{/* PAGE CODE */}

			<NavBarCustom actualRef={actualElement} />

			<div ref={homeRef} id="back-to-top-anchor" className="home-container">
				<img
					src={BackgroundImage}
					alt="Persona de pie con su laptop o ordenador, bajo un cielo estrellado con montañas nevadas, simbolizando visión y creatividad en desarrollo web y marketing digital personalizado."
					class="home-image"
				/>
				<div className="home-title">
					<h1>
						{t("home.title")}
						<br />
						<span className="home-title-hide">{t("home.title2")}</span>
					</h1>
				</div>
				<div className="home-subtitle">
					<h4 className="home-subtitle-text">{t("home.subtitle")}</h4>
				</div>
				<div className="home-button">
					<ButtonDesign
						data={{
							text: t("home.button"),
							dynamic: false,
							action: "redirect",
							to: "contacto",
						}}
					/>
				</div>
			</div>

			<Services innerRef={servicesRef} />
			<Reviews innerRef={reviewsRef} />
			<Portfolio innerRef={portfolioRef} />
			<Team innerRef={teamRef} />
			<Contact innerRef={contactRef} />
			<Footer innerRef={footerRef} />

			<ScrollTop props={props} />
		</div>
	);
};

export default HomePage;
